import { render, staticRenderFns } from "./add-paper-from-query.html?vue&type=template&id=1d362db5&scoped=true&"
import script from "./add-paper-from-query.js?vue&type=script&lang=js&"
export * from "./add-paper-from-query.js?vue&type=script&lang=js&"
import style0 from "./add-paper-from-query.scss?vue&type=style&index=0&id=1d362db5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d362db5",
  null
  
)

export default component.exports